<div class="prose">
  <h3>{{ 'pages.forceChangePassword.title.label' | translate }}</h3>
  <p class="mb-8">
    {{ 'pages.forceChangePassword.title.infoText' | translate }}
  </p>
</div>
<form class="flex flex-col items-start gap-4" [formGroup]="form">
  <formly-form
    class="w-full"
    [model]="model"
    [fields]="confirmResetFields"
    [form]="form"
    [options]="options"
  />
  <app-button
    type="primary"
    class="mt-4 w-full"
    data-test-id="submit-button"
    [disabled]="form.invalid"
    (trigger)="submit()"
  >
    {{ 'pages.forceChangePassword.submitButton.confirmChange' | translate }}
    @if (loading) {
      <svg-icon
        class="animate-spin"
        src="assets/icons/General/loading-01.svg"
      />
    }
  </app-button>
</form>
@if (errorText) {
  <p data-test-id="errorMessage" class="mt-4 text-red-600">{{ errorText }}</p>
}
